import { stringify } from 'qs'

export default (obj) => stringify(obj, { arrayFormat: 'brackets' })
